import { useMemo } from "react";
import { dateToJulianDate } from "../astronomy/julianDate";
import { calculateBodyRuntimeState } from "../astronomy/ephemeris";
import { catalogById, celestialBodyCatalog } from "../data/catalog";
import type { BodyRuntimeState } from "../types/celestialBody";

export function useCelestialPosition(
  bodyId: string,
  dateUtc: Date,
): BodyRuntimeState | null {
  return useMemo(() => {
    const body = catalogById.get(bodyId);
    if (!body) return null;
    const jd = dateToJulianDate(dateUtc);
    return calculateBodyRuntimeState(body, jd, catalogById);
  }, [bodyId, dateUtc]);
}

export function useAllCelestialPositions(dateUtc: Date): BodyRuntimeState[] {
  return useMemo(() => {
    const jd = dateToJulianDate(dateUtc);
    return celestialBodyCatalog.map((body) =>
      calculateBodyRuntimeState(body, jd, catalogById),
    );
  }, [dateUtc]);
}
